function productGridVideoReveal() {
  const productCardVideoElements = document.querySelectorAll('.media--hover-effect--video');

  productCardVideoElements.forEach((element) => {
    let videoParent = element.closest('.product-card-wrapper');
    let video = element.querySelector('video');

    videoParent.addEventListener('mouseover', (e) => {
      video.play();
    });

    videoParent.addEventListener('mouseout', (e) => {
      video.pause();
    });
  });
}

productGridVideoReveal();


